import React from 'react';
import './Footer.css';

const Footer = () => {
    return (
        <div>
            <div className='footer-area'>
                <p>Designed and Developed by <span className='text-[#1769FF]'>Mousumi Aktar</span></p>
                <p><span className='text-sm'>Copyright © 2022 Mousumi</span></p>
            </div>
        </div>
    );
};

export default Footer;